var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3442 0.975737C16.3442 0.436852 15.9377 0 15.4362 0H14.5282C14.0267 0 13.6202 0.436852 13.6202 0.975737V9.43212C13.6202 9.97101 14.0267 10.4079 14.5282 10.4079H15.4362C15.9377 10.4079 16.3442 9.97101 16.3442 9.43212V0.975737ZM10.0158 2.08157H10.9238C11.4253 2.08157 11.8319 2.52891 11.8319 3.08073V9.4087C11.8319 9.96052 11.4253 10.4079 10.9238 10.4079H10.0158C9.51435 10.4079 9.10782 9.96052 9.10782 9.4087V3.08073C9.10782 2.52891 9.51435 2.08157 10.0158 2.08157ZM6.32836 4.3366H5.42035C4.91887 4.3366 4.51234 4.78963 4.51234 5.34847V9.39598C4.51234 9.95482 4.91887 10.4079 5.42035 10.4079H6.32836C6.82985 10.4079 7.23638 9.95482 7.23638 9.39598V5.34847C7.23638 4.78963 6.82985 4.3366 6.32836 4.3366ZM1.81602 6.41818H0.908011C0.40653 6.41818 0 6.86474 0 7.4156V9.41044C0 9.9613 0.40653 10.4079 0.908011 10.4079H1.81602C2.3175 10.4079 2.72403 9.9613 2.72403 9.41044V7.4156C2.72403 6.86474 2.3175 6.41818 1.81602 6.41818Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNetwork);
export default __webpack_public_path__ + "static/media/mobile-network.8bd3b539c5df6c44c3f797ddf086d26f.svg";
export { ForwardRef as ReactComponent };